import React from 'react';

const CourseLessonFormModal = React.lazy(() => import('../components/FormModal'));
const courseLessonModalRegistry = {
    community_courseLessonId: CourseLessonFormModal
};
export default courseLessonModalRegistry;
